var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("section-headline", { attrs: { msg: "Einen Markt auswählen" } }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12" }, [
        _c(
          "form",
          {
            staticClass: "row mb-5",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-12 col-md-8" },
              [
                _c("multiselect", {
                  class: _vm.errors.id ? "error" : "",
                  attrs: {
                    options: _vm.merchants,
                    multiple: false,
                    "close-on-select": true,
                    "clear-on-select": false,
                    "preserve-search": false,
                    placeholder: "Standort auswählen",
                    selectedLabel: "Ausgewählt",
                    deselectLabel: "",
                    "group-label": "wholesaler",
                    "group-values": "merchants",
                    label: "name",
                    selectLabel: "",
                    "track-by": "name",
                    "preselect-first": true
                  },
                  model: {
                    value: _vm.form,
                    callback: function($$v) {
                      _vm.form = $$v
                    },
                    expression: "form"
                  }
                }),
                _vm._v(" "),
                _vm.errors.id
                  ? _c("div", { staticClass: "invalid-feedback d-block" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.errors.id[0]) +
                          "\n                "
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-4" }, [
      _c(
        "button",
        { staticClass: "btn btn-secondary w-100", attrs: { type: "submit" } },
        [_vm._v("Standort wählen")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }